import PropTypes from 'prop-types';
import React from 'react';
import { FamilyMember } from 'src/pages/facesheet/_id/Relationships/FamilyMember/FamilyMember';

export function FamilyMembersSection({
  className,
  contact,
  sectionTitle,
}) {
  if (!contact) {
    return null;
  }

  return (
    <FamilyMember
      className={className}
      person={contact}
      sectionTitle={sectionTitle}
      showHeader={false}
    />
  );
}

FamilyMembersSection.propTypes = {
  className: PropTypes.string,
  contact: PropTypes.shape({
    id: PropTypes.string,
  }),
  sectionTitle: PropTypes.string,
};

FamilyMembersSection.defaultProps = {
  className: '',
  contact: null,
  sectionTitle: '',
};

export default FamilyMembersSection;
